;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Button from "@mui/material/Button"
import { styled } from "@mui/material/styles"
import {
  UI_STYLE_PRIMARY_BLUE_BLACK,
  UI_STYLE_BLACK_COLOR_BUTTON,
  UI_STYLE_BLACK_COLOR_BUTTON_PUSHED,
  UI_STYLE_YELLOW_COLOR_BUTTON,
  UI_STYLE_YELLOW_COLOR_BUTTON_PUSHED,
  UI_STYLE_PRIMARY_FONT,
} from "../../../../../lib/constants"

const ColorButton = styled(Button)(({ theme }) => ({
  color: "white",
  backgroundColor: UI_STYLE_BLACK_COLOR_BUTTON,
  boxShadow: "none",

  width: "100%",
  maxWidth: "295px",
  height: "66px",
  filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25))",
  fontFamily: UI_STYLE_PRIMARY_FONT,
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "19px",
  textTransform: "unset",
  textAlign: "center",
  letterSpacing: "0.03em",
  borderRadius: "100px",
  "@media only screen and (min-width: 600px)": {
    fontSize: "18px",

    // width: "100%",
  },
  "&:hover": {
    backgroundColor: UI_STYLE_BLACK_COLOR_BUTTON_PUSHED,
  },
}))

export default ColorButton
